// Copyright (c) Bentley Systems
import {
  BrowserAuthorizationClient,
  BrowserAuthorizationClientConfiguration,
} from "@itwin/browser-authorization";
import { User, UserManager } from "oidc-client-ts";

export class BrowserAuthorizationClientImpl extends BrowserAuthorizationClient {
  constructor(options: BrowserAuthorizationClientConfiguration) {
    super(options);
  }

  public async getUser(): Promise<User | undefined> {
    const user = (await this._userManager?.getUser()) ?? undefined;
    return user;
  }

  public async getOidcUserManager(): Promise<UserManager> {
    return this.getUserManager();
  }
}
